import { _s } from '@/locale';
import Alert from '../elements/notifications/Alert/Alert';
import Icon from '../icons/Icon';

const baseTranslationKey = 'components.modules.BundleNoticeBanner';

const BundleNoticeBanner = ({ info = true }: { info?: boolean }) => {
  return info ? (
    <Alert
      variant="information"
      verticalAlign="top"
      leftSlot={<Icon variant="info-circle" />}
      title={_s(`${baseTranslationKey}.title`)}
      body={_s(`${baseTranslationKey}.description`)}
    />
  ) : (
    <div className="text-m space-x-xs">
      <span className="text-fg_primary font-bold">{_s(`${baseTranslationKey}.title`)}:</span>
      <span className="text-fg_secondary">{_s(`${baseTranslationKey}.description`)}</span>
    </div>
  );
};

export default BundleNoticeBanner;
